import React, { Component } from 'react'
import DocumentTitle from 'react-document-title'
import { inject } from 'mobx-react'
import PropTypes from 'prop-types'

import ExpertPaymentsList from './ExpertPaymentsList'
import ExpertPaymentsFilterPanel from './ExpertPaymentsFilterPanel'
import ExpertPaymentsStore from './expertPayments.store'

class ExpertPayments extends Component {
  static propTypes = {
    staticData: PropTypes.object.isRequired,
    growlStore: PropTypes.object.isRequired
  }

  constructor (props) {
    super(props)
    this.expertPaymentsStore = new ExpertPaymentsStore(
      props.staticData,
      props.growlStore
    )
    this.expertPaymentsStore.search()
  }
  render () {
    return (
      <DocumentTitle title='Expert Payments | Atheneum Partners'>
        <div className='expert-payments-page'>
          <ExpertPaymentsFilterPanel
            expertPaymentsStore={this.expertPaymentsStore}
          />
          <ExpertPaymentsList expertPaymentsStore={this.expertPaymentsStore} />
        </div>
      </DocumentTitle>
    )
  }
}

export default inject('staticData', 'growlStore')(ExpertPayments)
